export default __webpack_public_path__ + "static/media/Quote_Dark.2ca6a83b.svg";